import * as React from 'react';
import { Field } from 'redux-form';
const styles = require('./Profile.less') as any;
import classNames from 'classnames';
import { TextField, Checkbox, RadioButton, RadioGroup, SelectField, MenuItem } from '../../components/fields';

const Describes = ({firstName=''}) => (
	<Field name="describes" component={SelectField} label='This Profile Describes:'>
				<MenuItem value='myself' primaryText={`I am ${firstName}!`} />
				<MenuItem value='client' primaryText={`${firstName} is a client`} />
				<MenuItem value='family' primaryText={`${firstName} is a relative`} />
				<MenuItem value='friend' primaryText={`${firstName} is a friend`} />
		</Field>
);

const Gender = () => (
	<Field name="gender" component={SelectField} label='Sex'>
				<MenuItem value='male' primaryText='Male' />
				<MenuItem value='female' primaryText='Female' />
				<MenuItem value='other' primaryText='Other' />
		</Field>
);

const Name = (props) => (
	<Field name='name' component={TextField} label='Name' placeholder="John Smith" />
);

const Birth = () => (
	<Field name='birth_year' component={TextField} label='Birth year' placeholder="1955" />
);

const Diagnosis = () => (
	<Field name='diagnosis' component={TextField} label='Diagnosis' placeholder="Arthritis" />
);

const Zipcode = () => (
	<Field name='zipcode' component={TextField} label='Zipcode' placeholder='90210' />
);

const Radio = ({id, idx, value, anchor, length, selected, onSelected, ...props}) => {
		const htmlId = `fn${id}+idx${idx}`;
		const classes = classNames((idx == 0) && styles['fn-min'], (idx==length-1) && styles['fn-max']);
		return (
				<div className={styles.Radio}>
						<input type="radio" id={htmlId} name={id} {...props} onChange={()=>onSelected(value)} checked={selected} />
						<label className={classes} htmlFor={htmlId}><span>{anchor}</span></label>
				</div>
		);
};

import round from 'lodash/round';
import times from 'lodash/times';
const Radios = ({id, length, anchors, input}) => {
		const index_scaling_factor = (length-1/anchors.length-1);
		return (<div className={styles.RadioGroup}>
						{times(length, (idx) => {
								 // Find the corresponding anchor and ensure it reverse corresponds after rounding
								 const option_to_anchor = round(idx / index_scaling_factor);
								 const anchor_to_option = round(option_to_anchor * index_scaling_factor);
								 const anchor = anchor_to_option == idx ? anchors[option_to_anchor] : '';
								 const value = round(idx*(100/(length-1)), 0);

							 return (<Radio key={`${id}${idx}`} {...({
									 id, idx, anchor, value: {id, severity: value}, length, selected: input.value.severity===value,
									 onSelected: val => input.onChange(val)
								 })}/>);
						 })}
		</div>);
};

const Function = ({ id, prompt, anchors, examples }) => (
		<fieldset>
				<legend>{prompt}</legend>
				<Field name={`functions.${id}`} component={Radios} {...({id, anchors})} length={5} />
		</fieldset>
);

const renderFunction = (fn: any) => (
		<Function id={fn.id} anchors={[fn.min_anchor, fn.max_anchor]} prompt={fn.prompt}
							examples={[fn.example1, fn.example2, fn.example3]} />
);

const CONDITIONS = require('./Conditions.json').conditions as any;
import includes from 'lodash/includes';
import { Activatable } from '../utils'
const Impairments = ({onClick, selected, hide=[], show=null}) => (
		<ol className={styles.conditions}>
				{CONDITIONS
						.filter((val, id) => {
                return !includes(hide, val.id);
            })
						.filter((cond, idx) => {
                return (show && includes(show, cond.id)) || !show;
            })
						.map((condition, idx) => (
								<li key={`condition${idx}`} className={styles.impairment}>
									<Activatable className={styles.ImpairmentHeader} Element='header' onActivate={() => onClick(idx)} >
										{condition.name}
									</Activatable>
										{includes(selected, idx) && <ol className={styles.functions}>
												{condition.functions.map((fn, idx) => (
														 <li key={`condition${fn}-${idx}`} className={styles.Function}>{renderFunction(fn)}</li>
												 ))}
										</ol>}
								</li>
						))}
		</ol>
);

import MultiCheckbox from '../../components/MultiCheckbox';
const ASSISTIVE_TECH = require('./AssistiveTechnology.json').assistive_tech as any;

const AT = () => (
		<div className={styles.AssistiveTech}>
				<Field name="assistive_tech" component={MultiCheckbox} options={ASSISTIVE_TECH} className={styles.assistive_tech} />
				<Field name='assistive_tech_other' component={TextField} label="Other Assistive Technology" placeholder='Segway, hoverboard'
               style={{fontSize: '20px'}} />
		</div>
);

export { Name, Describes, Gender, Birth, Diagnosis, Zipcode, Impairments, AT };



// WEBPACK FOOTER //
// ./src/app/containers/Profile/ProfileFields.tsx